function setStickTableHeader() {
  if ($(document).width() > 767) {
    $('.sticky-table-header').stickyTableHeaders();
  } else {
    $('.sticky-table-header').stickyTableHeaders('destroy');
  }
}

setStickTableHeader();

$(window).resize(function() {
  setStickTableHeader();
});
